import { generatePath } from 'react-router-dom';
import { Country } from '@tiendanube/common/src/enums';
import ShowByCountry from 'App/components/ShowByCountry';
import { NUVEMENVIO_LOGGI_BANNER } from 'App/featuresFlags';
import { useNavegate } from 'App/hooks';
import { useResponsive } from 'commons/components';
import { useDismissibleComponent } from 'commons/hooks';
import { useGetTags } from 'domains/Auth/hooks';
import {
  trackingNuvemEnvioLoggiBannerClose,
  trackingNuvemEnvioLoggiBannerClick,
} from 'domains/NuvemEnvioCommons/tracking';
import { PARTNER_APPS_ROUTES } from 'domains/PartnersApps/partnersAppsRoutes';
import BannerDesktop from '../BannerDesktop';
import BannerMobile from '../BannerMobile';

function ColectaLoggiBanner() {
  const { isMobile: isMobileResponsive } = useResponsive();
  const { goTo } = useNavegate();

  const hasColectaLoggiBanner = useGetTags().includes(NUVEMENVIO_LOGGI_BANNER);
  const { shouldShow, dismiss } = useDismissibleComponent(
    'loggi-banner-dismiss',
    90,
  );

  const handleClick = () => {
    trackingNuvemEnvioLoggiBannerClick();
    goTo(
      generatePath(
        `${PARTNER_APPS_ROUTES.nuvemenvioConfigurations}/carrier/loggi`,
      ),
    );
  };

  const handleClose = () => {
    trackingNuvemEnvioLoggiBannerClose();
    dismiss();
  };

  if (!shouldShow || !hasColectaLoggiBanner) {
    return null;
  }

  return (
    <ShowByCountry allowedCountries={[Country.BR]}>
      <>
        {isMobileResponsive && (
          <BannerMobile
            onClose={handleClose}
            onClick={handleClick}
            translateKey="loggiBanner"
          />
        )}
        {!isMobileResponsive && (
          <BannerDesktop
            onClose={handleClose}
            onClick={handleClick}
            translateKey="loggiBanner"
          />
        )}
      </>
    </ShowByCountry>
  );
}

export default ColectaLoggiBanner;
